<annotate-annotation-list
    [skipped]="skipped"
    [label]="label"
    (labelChange)="labelChange.emit($event)">
    <ng-template #actionsTemplate let-annotation="annotation">
        <i class="dku-icon-label-multiple-16 mleft4 mright8 annotation-list__icon" [class.annotation-list__icon--disabled]="!annotation.category" (click)="createMatchingAnnotations(annotation)" [matTooltip]="annotation.category ? 'Apply annotation to all occurrences' : 'Category must be selected in order to apply annotation to all occurrences'"></i>
    </ng-template>
</annotate-annotation-list>